module.exports = __webpack_public_path__ + "img/zhifubao_back.271c086a.png";